module.exports = __webpack_public_path__ + "static/media/edinburgh-37.4c141b11.jpg";